import { useTemplateInImage } from "../../../platform/studio/image/prompt-template-handoff";
import { PromptTemplateBrowser } from "../../../platform/studio/image/PromptTemplates";
import classes from "./tabs.module.css";

/** No draft here: no template is the one the composer holds, so none is outlined. */
const NO_DRAFT = { prompt: "", referenceIds: [] };

export interface PromptTemplatesTabProps {
  teamId: string;
  brandId: string;
}

/**
 * Pro's Library > Prompt templates (spec ui-perf/pro-library-tabs): the composer's own panel body,
 * the brand's Custom and live's Global templates with one search and sort, whose "Use in Image"
 * opens Pro's Image page with the template applied. Live has the panel alone, in the composer.
 */
export function PromptTemplatesTab({ teamId, brandId }: PromptTemplatesTabProps) {
  const useInImage = useTemplateInImage(teamId, brandId);
  return (
    <div className={classes.box}>
      <PromptTemplateBrowser draft={NO_DRAFT} onApply={useInImage} applyLabel="Use in Image" />
    </div>
  );
}
